module.exports = __webpack_public_path__ + "img/leeb-balkone-mitarbeiter-27.d3d4829a.jpg";